import dayjs from 'dayjs'

export const sortByValidity = (items = []) => {
  const today = dayjs()

  const groupedItems = items.reduce(
    (groups, item) => {
      const validFrom = dayjs(item.validfrom)

      const category = item.isActivated
        ? 'activated'
        : validFrom.isSameOrBefore(today, 'day')
          ? 'notActivated'
          : 'preview'
      groups[category].push(item)

      return groups
    },
    {
      notActivated: [],
      activated: [],
      preview: []
    }
  )

  const sortItems = (a, b) => {
    const validFromA = dayjs(a.validfrom)
    const validFromB = dayjs(b.validfrom)

    if (validFromA.isBefore(validFromB)) return -1
    if (validFromA.isAfter(validFromB)) return 1

    const validToA = dayjs(a.validto)
    const validToB = dayjs(b.validto)

    if (validToA.isBefore(validToB)) return -1
    if (validToA.isAfter(validToB)) return 1

    return (a.title ?? '').localeCompare(b.title ?? '')
  }

  const sort = arr => [...arr].sort(sortItems)

  return [
    ...sort(groupedItems.notActivated),
    ...sort(groupedItems.activated),
    ...sort(groupedItems.preview)
  ]
}
